import React from 'react';
import {
  TableHead, TableRow, TableCell, TableSortLabel, IconButton,
} from '@material-ui/core';
import './table-header.scss';
import { InfoIcon } from 'components/icons/info';
import { InfoOutlinedIcon } from 'components/icons/info-outlined';
import { TableHeaderProps } from './table-header-props';
import { Column } from '../column';


/**
 * Table header component that wraps thead.
 */
export const TableHeader: React.FC<TableHeaderProps> = React.forwardRef((props, ref) => {
  const {
    openTooltipId,
    onInfoIconClick,
    sortBy,
  } = props;

  const onHeaderSelected = (column: Column) => {
    // Use ASBV label (abbrev) instead of id as this is what the API expects.
    // TODO: Update to use id.
    const {
      label, id, enableSort, sortDir,
    } = column;
    if (enableSort) {
      const sortDirection = sortDir === 'desc' ? 'asc' : 'desc';
      // returns id or label depend on what is requested from prop sortBy
      if (props.headerSelected) {
        if (sortBy === 'id') {
          props.headerSelected(id, sortDirection);
        } else {
          props.headerSelected(label, sortDirection);
        }
      }
    }
  };

  /**
   * Sets the open tooltip id.
   * @param id
   */
  const infoIconClick = (id: string) => {
    if (onInfoIconClick) {
      const showTooltip = id !== openTooltipId;
      onInfoIconClick(showTooltip, id);
    }
  };

  return (
    <>
      <TableHead ref={ref} className="sg-table__header">
        <TableRow>
          {props.columns.map((column: Column, index: number) => (
            <TableCell
              key={`${column.id.toString() + index}`}
              align={column.align}
              className={`cell ${column.isSticky ? 'sticky' : ''}`}
              style={{ width: props.cellsWidth ? props.cellsWidth[index] : 'auto' }}
              sortDirection={column.sortDir}
            >
              <div
                className="sg-table__sort"
                role="button"
                onClick={() => onHeaderSelected(column)}
                onKeyPress={() => onHeaderSelected(column)}
                tabIndex={0}
              >
                <TableSortLabel
                  active={column.isSorted}
                  direction={column.sortDir}
                  hideSortIcon
                />
                {column.label}
              </div>
              {(props.showInfoIcon && column.hasInfo) && (
                <IconButton
                  className={`sg-relative-tooltip__button ${openTooltipId === column.id ? 'active' : ''}`}
                  size="small"
                  aria-label="info"
                  onClick={() => infoIconClick(column.id)}
                >
                  {openTooltipId !== column.id && (<InfoOutlinedIcon />)}
                  {openTooltipId === column.id && (<InfoIcon />)}
                </IconButton>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
});
